import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse, ForumInfo, ForumInfoParams } from "./types";

// 论坛相关API
export const forumApi = {
  /**
   * 获取指定分区的帖子分类
   * @param forum_name - 论坛分区名称, 对应game_id
   * @param limit - 限制数量，默认100
   * @param language - 语言
   * @returns Promise<ApiResponse<ForumInfo>>
   */
  getInfo: (
    forum_name: string,
    language: string,
    limit: number = 100
  ): Promise<ApiResponse<ForumInfo>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FORUM,
      API_CONFIG.ACTIONS.FORUM_INFO,
      {
        forum_name,
        target_language: language,
        limit,
      }
    );
    return get<ApiResponse<ForumInfo>>(url);
  },

  /**
   * 获取指定分区的帖子数据
   * @param forum_name - 论坛ID
   * @param language - 语言
   * @param fid - 分类ID
   * @param page - 页码，默认1
   * @param page_size - 每页数量，默认100
   * @param orderBy - 排序方式：dateline(发布时间) 或 lastpost(最后回复时间)，默认dateline
   * @param is_recommend - 是否推荐，默认false
   * @returns Promise<ApiResponse<ForumInfo>>
   */
  getThreads: (
    forum_name: string,
    language: string,
    fid: number,
    page: number = 1,
    page_size: number = 100,
    order_by: "dateline" | "lastpost" = "dateline",
    is_recommend: number = 0
  ): Promise<ApiResponse<ForumInfo>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FORUM,
      API_CONFIG.ACTIONS.FINFO,
      {
        forum_name,
        target_language: language,
        fid,
        page,
        page_size,
        order_by,
        is_recommend,
      }
    );
    return get<ApiResponse<ForumInfo>>(url);
  },
  /**
   * 签到
   * @returns Promise<ApiResponse>
   */
  sign: (game_id: string): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FORUM,
      API_CONFIG.ACTIONS.FORUM_SIGN,
      { game_id }
    );
    return get<ApiResponse>(url);
  },
};
